<script setup>
import { reactive, computed, onMounted, onBeforeUnmount, watch, ref, nextTick } from 'vue'

import { useGlobalStore } from '@/stores/useGlobalStore'
import { useUserStore } from '@/stores/useUserStore'

import utils from '@/utils.js'
import consts from '@/consts.js'

const globalStore = useGlobalStore()
const userStore = useUserStore()

const isResizing = computed(() => globalStore.currentUserIsResizingSidebar)
const start = (event) => {
  if (utils.isMultiTouch(event)) { return }
  globalStore.currentUserIsResizingSidebar = true
}

const remove = (event) => {
  globalStore.currentUserIsResizingSidebar = false
  userStore.updateUser({ sidebarResizeWidth: consts.defaultDialogWidth })
}
</script>

<template lang="pug">
.right-resize.sidebar-resize-wrap.bottom-button-wrap(@click.stop)
  .inline-button-wrap(
    @mousedown.left.stop="start"
    @touchstart.stop="start"
    @dblclick="remove"
    title="Drag to Resize"
  )
    button.inline-button(tabindex="-1" :class="{active: isResizing}")
      img.icon(src="@/assets/resize-corner.svg")
</template>

<style lang="stylus">
.sidebar
  .sidebar-resize-wrap
    pointer-events none
    position absolute
    left -7px
    bottom 2px
    display flex
    .inline-button-wrap
      pointer-events all
      margin-right 0
      margin-top 0
      padding 12px
      padding-left 0
      padding-bottom 0
      z-index 1
      cursor ew-resize
      button
        cursor ew-resize
        box-shadow none
      &:hover
        button
          box-shadow none
          background var(--light-shadow) !important
      &.active,
      &:active
        button
          box-shadow none
          background var(--heavy-shadow) !important
    .icon
      -webkit-user-drag none
      user-drag none
      user-select none
      position absolute
      left 0
      top 0
      transform scaleX(-1)
    .right-resize
      .inline-button-wrap
        padding-left 0
</style>
